import { gql } from "@apollo/client";

export const generateCompanyPolicyNudges = gql`
  mutation generateCompanyPolicyNudges($companyPolicyId: MongoID!, $nudgeCount: Int!, $metaData: String, $policyName: String) {
    CompanyPolicyNudge_Generate(companyPolicyId: $companyPolicyId, nudgeCount: $nudgeCount, metaData: $metaData, policyName: $policyName) {
      _id
      title
      description
    }
  }
`;
